var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"study"},[_c('div',{staticClass:"study-play"},[_c('rules')],1)]),_vm._v(" "),_c('law'),_vm._v(" "),_c('div',{staticClass:"nameSearch"},[_c('div',{staticClass:"nameSearch-Play"},[_c('name-search')],1)]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-play"},[_c('operation')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98fa3cda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/search.vue
// module id = null
// module chunks = 